export default function HaileyCollapseIco() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33325 16.6663L8.33325 11.6663M16.6666 3.33301L11.6666 8.33301"
        stroke="#344054"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 11.667H8.33333V15.0003"
        stroke="#344054"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0001 8.33333H11.6667V5"
        stroke="#344054"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
